import styled from 'styled-components';

const Loader = ({ className }) => {
  return (
    <Wrapper className={className}><div /><div /><div /></Wrapper>
  );
}

export default styled(Loader)``;

const Wrapper = styled.div`
  display: inline-block;
  position: relative;
  width: 10px;
  height: 22px;
  vertical-align: middle;

  div {
    display: inline-block;
    position: absolute;
    width: 2px;
    height: 16px;
    background: var(--lizzy-blue);
    transform-origin: center;
    border-radius: 2px;
    transition: all .3s ease;
    animation: anim .7s ease infinite;
    top: 3px;
  }

  div:nth-child(1) {
    left: 0px;
    animation-delay: -0.3s;
  }

  div:nth-child(2) {
    left: 4px;
    animation-delay: -0.15s;
    height: 22px;
    top: 0px;
  }

  div:nth-child(3) {
    left: 8px;
    animation-delay: 0;
  }

  @keyframes anim {
    0% {
      transform: scaleY(0.7) scaleX(.8);
      opacity: .7;
    }
    50% {
      transform: scaleY(1) scaleX(1);
      opacity: 1;
    }
    100% {
      transform: scaleY(0.7) scaleX(.8);
      opacity: .7;
    }
  }
`;